<template>
  <div class="nenhum-terceiro-informado">
    <div class="nenhum-terceiro-informado__icone-wrapper">
      <i
        class="mdi mdi-account-group-outline nenhum-terceiro-informado__icone"
        aria-hidden="true"
      ></i>
    </div>
    <p v-if="modoVisualizacao" class="nenhum-terceiro-informado__texto">
      Nenhum terceiro informado.
    </p>
    <p v-else class="nenhum-terceiro-informado__texto">
      Nenhum terceiro informado. Clique em
      <span class="nenhum-terceiro-informado__destaque">Incluir Envolvido</span>
      para adicionar.
    </p>
  </div>
</template>

<script lang="js">
/**
 * Estado vazio da lista de terceiros.
 *
 * Em visualização (`inject modoVisualizacao=true` via
 * `VisualizarRelatoOcorrenciaContainer`) exibe só "Nenhum terceiro
 * informado.", sem o convite para incluir (sem ação disponível).
 */
export default {
  name: "NenhumTerceiroInformado",

  inject: {
    modoVisualizacao: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/components/_nenhum-terceiro-informado";
</style>


